export default __webpack_public_path__ + "static/media/icon_youtube_creator.61f20a55.svg";